import styled from '@emotion/styled';
import { Css, Responsive } from '../../../ui';

export const Container = styled.div`
	position: relative;
	height: ${Css.pxToRem(114)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		height: ${Css.pxToRem(52)};
	}
`;

export const ScrollingWrapper = styled.div`
	position: absolute;
	width: 100%;
	pointer-events: none;
`;

export const StickyWrapper = styled.div<{ isSticky: boolean }>`
	z-index: 100;

	${({ isSticky }) => {
		if (!isSticky) {
			return null;
		}

		return `
			position: fixed;
			left: 0;
			right: 0;
			top: 0;
		`;
	}}
`;

export const Wrapper = styled.div<{ isSticky: boolean }>`
	position: relative;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		height: auto;
	}

	${({ isSticky }) => {
		if (isSticky) {
			return `
				position: fixed;
				left: 0;
				right: 0;
			`;
		}
		return null;
	}}
`;
